__turbopack_context__.v({
  "loadingContainer": "LocalDeliveryMap-module__Bwi3yW__loadingContainer",
  "mapContainer": "LocalDeliveryMap-module__Bwi3yW__mapContainer",
  "refreshText": "LocalDeliveryMap-module__Bwi3yW__refreshText",
  "timestamp": "LocalDeliveryMap-module__Bwi3yW__timestamp",
});
